import { DefaultState } from '@src/redux/types'

import { LOGS_ASSESSMENT_STUDENT_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [LOGS_ASSESSMENT_STUDENT_LIST]: DefaultState<`${typeof API.LOGS_ASSESSMENT_STUDENT_LIST}`, 'get'>
} = () => ({
  [LOGS_ASSESSMENT_STUDENT_LIST]: defaultState(),
})
